import api from "./api";
import StorageService from "./StorageService";

const VehicleRegistrationService = {


  create: async (data) => {
    const login = StorageService.loginData();
    const activeCompany = StorageService.activeCompany();

    const payload = {
      ...data,
      companyId: activeCompany.companyId,
      createdBy: login.employeeId,
      updatedBy: login.employeeId,
    };

    const response = await api.post("/vehicleRegistration/save", payload);
    return response.data;
  },


  getAll: async (pageNumber = 1, noOfRows = 20, search = "") => {
    const activeCompany = StorageService.activeCompany();

    const response = await api.get(`/vehicleRegistration/getAll`, {
      params: {
        companyId: activeCompany.companyId,
        pageNumber,
        noOfRows,
        search
      },
    });

    return response.data.data || response.data;
  },


  getActiveVehicles: async () => {
    const activeCompany = StorageService.activeCompany();

    const response = await api.get(`/vehicleRegistration/getActive`, {
      params: { companyId: activeCompany.companyId },
    });

    return response.data.data || response.data;
  },


  getById: async (id) => {
    const activeCompany = StorageService.activeCompany();

    const response = await api.get(`/vehicleRegistration/getById/${id}`, {
      params: { companyId: activeCompany.companyId },
    });

    return response.data;
  },


  getByVehicleTypeId: async (vehicleTypeId, companyId) => {
    const response = await api.get(
      `/vehicleRegistration/getByVehicleTypeId/${vehicleTypeId}`,
      {
        params: { companyId },
      }
    );
    return response.data;
  },


  getByProjectId: async (id, includeReleased = false, date = null) => {
    const response = await api.get(
      `/vehicleRegistration/getByProjectId/${id}`,
      {
        params: { includeReleased, date }
      }
    );
    return response.data;
  },


  update: async (id, data) => {
    const login = StorageService.loginData();
    const activeCompany = StorageService.activeCompany();

    const payload = {
      ...data,
      companyId: activeCompany.companyId,
      updatedBy: login.employeeId,
    };

    const response = await api.put(
      `/vehicleRegistration/update/${id}`,
      payload
    );
    return response.data;
  },


  remove: async (id) => {
    const response = await api.delete(`/vehicleRegistration/${id}`);
    return response.data;
  },


  updateStatus: async (id) => {
    const response = await api.put(
      `/vehicleRegistration/updateStatus/${id}`
    );
    return response.data;
  },

  // vehicleRegistrationService.js (frontend)

  exportVehicleRegistration: async (companyId) => {
    const response = await api.get(
      `/vehicleRegistration/export?companyId=${companyId}`
    );
    return response.data;
  },

};

export default VehicleRegistrationService;
